import { style, styleVariants } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";

const baseStyles = style({
  display: "inline-block",
  borderRadius: vars.radii.xs,
  minWidth: 40,
  verticalAlign: "middle",
  textAlign: "center",
  lineHeight: "2.1rem",
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.s,
});

export const historyResultStyles = styleVariants({
  l: [
    baseStyles,
    { backgroundColor: vars.colors.result.l, color: vars.colors.white },
  ],
  d: [
    baseStyles,
    { backgroundColor: vars.colors.result.d, color: vars.colors.primaryFixed },
  ],
  w: [
    baseStyles,
    { backgroundColor: vars.colors.result.w, color: vars.colors.primaryFixed },
  ],
});
